module.exports = __webpack_public_path__ + "static/home-hero.942cc750.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/videos/home-hero.mp4
// module id = 945
// module chunks = 35783957827783